import React from 'react'
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer'
import type { ReportData, DateRange } from './types'

const styles = StyleSheet.create({
  page: { padding: 30, fontSize: 10, fontFamily: 'Helvetica' },
  header: { fontSize: 18, marginBottom: 10, fontFamily: 'Helvetica-Bold' },
  dateRange: { fontSize: 10, marginBottom: 20, color: '#666' },
  table: { width: '100%', marginTop: 10 },
  tableRow: { flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#e5e7eb', paddingVertical: 8 },
  tableHeader: { flexDirection: 'row', borderBottomWidth: 2, borderBottomColor: '#374151', paddingVertical: 8, backgroundColor: '#f3f4f6' },
  tableCell: { flex: 1, paddingHorizontal: 5 },
  tableCellHeader: { flex: 1, paddingHorizontal: 5, fontFamily: 'Helvetica-Bold' },
  summary: { marginTop: 20, padding: 15, backgroundColor: '#f9fafb', borderRadius: 5 },
  summaryTitle: { fontSize: 14, fontFamily: 'Helvetica-Bold', marginBottom: 10 },
  summaryItem: { flexDirection: 'row', marginVertical: 3 },
  summaryLabel: { fontFamily: 'Helvetica-Bold', marginRight: 5 },
})

interface Props {
  data: ReportData
  title: string
  dateRange?: DateRange
}

export const ReportPDFDocument: React.FC<Props> = ({ data, title, dateRange }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Text style={styles.header}>{title}</Text>
      {dateRange && (
        <Text style={styles.dateRange}>{`Period: ${dateRange.start} to ${dateRange.end}`}</Text>
      )}

      <View style={styles.table}>
        <View style={styles.tableHeader}>
          {data.headers.map((header, idx) => (
            <Text key={idx} style={styles.tableCellHeader}>{header}</Text>
          ))}
        </View>
        {data.rows.slice(0, 50).map((row, rowIdx) => (
          <View key={rowIdx} style={styles.tableRow}>
            {row.map((cell, cellIdx) => (
              <Text key={cellIdx} style={styles.tableCell}>
                {cell !== null && cell !== undefined ? String(cell) : '-'}
              </Text>
            ))}
          </View>
        ))}
      </View>

      {data.summary && (
        <View style={styles.summary}>
          <Text style={styles.summaryTitle}>Summary</Text>
          {Object.entries(data.summary).map(([key, value], idx) => (
            <View key={idx} style={styles.summaryItem}>
              <Text style={styles.summaryLabel}>{key}:</Text>
              <Text>{value !== null && value !== undefined ? String(value) : '-'}</Text>
            </View>
          ))}
        </View>
      )}
    </Page>
  </Document>
)
